import React, { memo, ReactElement } from "react";

interface PlusIconProps {
    className?: string;
    size?: number;
    iconFillColor?: string;
}

const DEFAULT_ICON_SIZE = 12;
const DEFAULT_ICON_FILL_COLOR = "#909197";

function PlusIcon(props: PlusIconProps): ReactElement {
    const { className, size = DEFAULT_ICON_SIZE, iconFillColor: IconFillColor = DEFAULT_ICON_FILL_COLOR } = props;
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.00001 0.408556C6.54475 0.408563 6.98635 0.850169 6.98634 1.39491L6.98629 5.01371L10.6051 5.01366C11.1498 5.01366 11.5914 5.45525 11.5914 5.99999C11.5914 6.54473 11.1498 6.98634 10.6051 6.98635L6.98627 6.98639L6.98622 10.605C6.98621 11.1497 6.54461 11.5913 5.99987 11.5913C5.45513 11.5913 5.01353 11.1497 5.01354 10.605L5.01359 6.98642L1.395 6.98646C0.850257 6.98647 0.408652 6.54488 0.408645 6.00014C0.408637 5.4554 0.850231 5.01379 1.39497 5.01378L5.01361 5.01374L5.01366 1.39488C5.01367 0.850143 5.45527 0.408549 6.00001 0.408556Z"
                fill={IconFillColor}
            />
        </svg>
    );
}

export default memo(PlusIcon);
